import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CLAIMDOCUMENTTYPES_FEATURE_KEY,
  ClaimDocumentTypesState,
  claimDocumentTypeEntityAdapter
} from './claim-document-types.reducer';

// Lookup the 'ClaimDocumentTypes' feature state managed by NgRx
const getClaimDocumentTypesState = createFeatureSelector<
  ClaimDocumentTypesState
>(CLAIMDOCUMENTTYPES_FEATURE_KEY);

export const {
  selectIds: getClaimDocumentTypeIds,
  selectEntities: getClaimDocumentTypeEntities,
  selectAll: getAllClaimDocumentTypes,
  selectTotal: getTotalClaimDocumentTypes
} = claimDocumentTypeEntityAdapter.getSelectors(getClaimDocumentTypesState);

const getLoaded = createSelector(
  getClaimDocumentTypesState,
  (state: ClaimDocumentTypesState) => state.loaded
);

const getLoading = createSelector(
  getClaimDocumentTypesState,
  (state: ClaimDocumentTypesState) => state.loading
);

const getError = createSelector(
  getClaimDocumentTypesState,
  (state: ClaimDocumentTypesState) => state.error
);

const getSelectedId = createSelector(
  getClaimDocumentTypesState,
  (state: ClaimDocumentTypesState) => state.selectedId
);

const getSelectedIds = createSelector(
  getClaimDocumentTypesState,
  (state: ClaimDocumentTypesState) => state.selectedIds
);

const getSelectedClaimDocumentType = createSelector(
  getClaimDocumentTypeEntities,
  getSelectedId,
  (claimDocumentTypes, id) => {
    const result = claimDocumentTypes[id];
    return result ? Object.assign({}, result) : undefined;
  }
);

const getSelectedClaimDocumentTypes = createSelector(
  getClaimDocumentTypeEntities,
  getSelectedIds,
  (claimDocumentTypes, ids) => {
    const result = ids.map(id => claimDocumentTypes[id]);
    return result ? Object.assign([], result) : [];
  }
);

export const claimDocumentTypesQuery = {
  getLoaded,
  getLoading,
  getError,
  getAllClaimDocumentTypes,
  getSelectedClaimDocumentType,
  getSelectedClaimDocumentTypes
};
